import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { EComandaMesaEstado } from '@core/enums/comanda.enum';
import { MesaRes } from '@core/interfaces/request-response/comanda.dto';
import { estadoGeneralMesaPorProductos } from '@shared/utils/functions.utils';

@Component({
  selector: 'app-card-comanda',
  imports: [CommonModule, CurrencyPipe],
  templateUrl: './card-comanda.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-comanda.css',
})
export class CardComanda {
  // datos
  mesa = input.required<MesaRes>();
  modoEdicion = input.required<boolean>();

  EComandaMesaEstado = EComandaMesaEstado;

  editar = output<MesaRes>();

  calcularTotal = computed((): number => {
    return (
      this.mesa().comanda?.productos.reduce(
        (total, producto) => total + producto.precio_unitario * producto.cantidad,
        0,
      ) || 0
    );
  });
  // metodos
  estadoProductoMesa = computed((): EComandaMesaEstado => {
    return estadoGeneralMesaPorProductos(this.mesa().comanda?.productos || []);
  });

  horaApertura = computed((): string => {
    if (!this.mesa().comanda) return '00:00';
    const fechaApertura = new Date(this.mesa().comanda?.productos.at(0)?.created_at || '');
    const horas = fechaApertura.getHours().toString().padStart(2, '0');
    const minutos = fechaApertura.getMinutes().toString().padStart(2, '0');
    return `${horas}:${minutos}`;
  });

  /** Personas reales de la comanda; evita datos fijos en la tarjeta. */
  subtituloMesa = computed((): string => {
    const mesa = this.mesa();
    if (mesa.estado === EComandaMesaEstado.LIBRE) return 'Disponible';

    const clientes = mesa.comanda?.clientes;
    if (clientes && clientes > 0) {
      return `${clientes} ${clientes === 1 ? 'persona' : 'personas'}`;
    }

    return mesa.capacidad ? `Capacidad ${mesa.capacidad}` : 'Ocupada';
  });
}
